import { RefObject, useEffect, useRef, useState } from 'react';

export default function useOnScreen<Element extends HTMLElement>(
  offset = 0,
  throttleMilliseconds = 1000,
): [RefObject<Element>, boolean] {
  const [isVisible, setIsVisible] = useState(false);
  const [timer, setTimer] = useState<NodeJS.Timer>();
  const ref = useRef<Element>();

  const debounce = (func: () => void) => () => {
    const newTimer = setTimeout(func, throttleMilliseconds);
    clearTimeout(timer);
    setTimer(newTimer);
  };

  const onScroll = debounce(() => {
    if (!ref.current) return setIsVisible(false);
    const top = ref.current.getBoundingClientRect().top;
    setIsVisible(top + offset >= 0 && top - offset <= window.innerHeight);
  });

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  });

  return [ref as RefObject<Element>, isVisible];
}
